import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from 'semantic';
import ThemedSegment from 'components/semantic/Segment';
import { TariffDescription as DescriptionType } from 'screens/GroupsAndPolicies/types';

type Props = {
  values: DescriptionType;
  onEdit?: () => void;
  onRemove?: () => void;
};

export const TariffDescriptionPreview: React.FC<Props> = ({
  values,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <ThemedSegment offbackground>
      {/* TODO: there must be a better way to align this with Semantic? */}
      <Grid columns="equal" verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={2}>
            <p style={{ lineBreak: 'anywhere' }}>
              {t('tariff.description', 'Description')}
            </p>
          </Grid.Column>
          <Grid.Column width={12}>
            <p>
              {values?.language?.toUpperCase()}: {values?.text}
            </p>
          </Grid.Column>
          <Grid.Column floated="right" width={2}>
            {onEdit && (
              <Button icon="edit" basic size="mini" onClick={onEdit} />
            )}
            {onRemove && (
              <Button
                icon="trash"
                basic
                size="mini"
                onClick={onRemove} // TODO: add prompt?
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ThemedSegment>
  );
};
